import React from 'react'
import { PageBarFrame } from './PageBarFrame'
import { PageBarSubject } from './PageBarSubject'

interface Props {
  title: React.ReactNode
  /** Where leaving the task goes — a route, or a handler for an unsaved-work prompt. */
  onClose?: () => void
  closeTo?: string
  /** A step indicator or similar; a focused task gets no other furniture. */
  children?: React.ReactNode
}

export const TaskPageBar = ({ title, onClose, closeTo, children }: Props) => (
  <PageBarFrame>
    <PageBarSubject>{title}</PageBarSubject>
    {children}
    <a
      href={closeTo}
      onClick={
        onClose
          ? e => {
              e.preventDefault()
              onClose()
            }
          : undefined
      }
      aria-label="Close"
      className="ml-auto flex h-8 w-8 flex-shrink-0 cursor-pointer items-center justify-center rounded-lg text-mm-neutral-1-600 transition-colors hover:bg-mm-neutral-1-100"
    >
      <i className="fad fa-times" aria-hidden />
    </a>
  </PageBarFrame>
)
